'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * API query example for fetching sorted list of report IDs:
 *
 * api.query('list').then(processJson).then(function (response) {
 *   const data = response.ok && response.body && response.body.data
 *   const reports = []
 *
 *   for (const reportId in data) {
 *     reports.push({ id: reportId, name: data[reportId].name, uriTemplate: data[reportId].uriTemplate })
 *   }
 *
 *   const sortedReports = reports.sort(function (a, b) {
 *     const aName = a.name.toLowerCase()
 *     const bName = b.name.toLowerCase()
 *
 *     if (aName < bName) return -1
 *     if (aName > bName) return 1
 *     return 0
 *   })
 * })
 */

var REPORT_IDS = [{
  id: 'a0bdf18f6353b716a72842ee91550cbce9a669cf2db1b6d13c277e2e091287da',
  name: 'Adset Status Violation',
  uriTemplate: '/reports/customer/unified/adset_status_violation'
}, {
  id: '4a0b1f1e947b643c87efc0e5d5a6a62eabb119a7612e8d61fe1cb6381d6d3d30',
  name: 'Awesm Links Stats',
  uriTemplate: '/reports/awesm/awesm_links_stats'
}, {
  id: '418c259f16174177f2ac9860dca42443ada0689a8c26e980a6f46c9ff1178250',
  name: 'Awesm Links Stats',
  uriTemplate: '/reports/awesm_v1_0/awesm_links_stats'
}, {
  id: 'edb53bbcdce648a16e8db2af7f9f03e54d539120508a1f8b7d932fa77c6a40d2',
  name: 'Awesm Links Stats',
  uriTemplate: '/reports/awesm_v1_0/links_stats'
}, {
  id: 'd89e619e199228f3be884f7a99f9f4cda2f662e4a31843ecf8b6ac945579858f',
  name: 'Awesm Links Stats',
  uriTemplate: '/reports/awesm/links_stats'
}, {
  id: '6a762be1dfef0462ec6330ea5feef616fd836667a9d02066bdfec95b9e939eca',
  name: 'Batch Line Item Pacing',
  uriTemplate: '/reports/line_items/pacing'
}, {
  id: '8ecf4913c216fb331c3e2104113c38949d2ff443658e3688aa4f13977b5e4dc1',
  name: 'Business Organization',
  uriTemplate: '/reports/customer/business_organization'
}, {
  id: 'b05eb870dd1e0223889693ad48be4da8cde62ee27ad779df2107fc5af79d837c',
  name: 'Credential Monitor',
  uriTemplate: '/reports/monitor/credentials'
}, {
  id: '30ca932ae196ba9fb6ca5fb119a0e6e426d7b7a9668f41d960d26af80407f644',
  name: 'Describe Report',
  uriTemplate: '/reports/reports/{report_id}'
}, {
  id: '9e8cca4df84275511f7b7ef3758d21c4581c12a622696e1f0ad05fe533d1405e',
  name: 'Facebook Ad Creatives Report',
  uriTemplate: '/reports/instagram_v2_8/adcreatives'
}, {
  id: '43a58a8fd8d14870bfbb283b56f43a6c86778781ebd2b2badd2ea122c85a3b57',
  name: 'Facebook Ad Creatives Report',
  uriTemplate: '/reports/facebook_v2_8/adcreatives'
}, {
  id: '39fdf07518b2878473bfd341e9c2c638932f1ae23d12a6159052b3a179f1e7e3',
  name: 'Facebook Ad Previews Report',
  uriTemplate: '/reports/instagram_v2_8/adcreatives/preview'
}, {
  id: 'a3a109d2e3566260066b773a04cfbf892f4dc60bbc37209aefa90c1525e3c988',
  name: 'Facebook Ad Previews Report',
  uriTemplate: '/reports/facebook_v2_8/adcreatives/preview'
}, {
  id: 'e16fb9ee94efb845e1904439d7df07f604be34ec2e6280d8deebb710ab3e1722',
  name: 'Facebook Ad Report Stats Report',
  uriTemplate: '/reports/facebook_v2_7/reportstats/{stats_type}'
}, {
  id: 'd0ba7518c7f048e28a083662a2b96ca59bb6616a512db92a47434cda80e21e0b',
  name: 'Facebook Ad Report Stats Report',
  uriTemplate: '/reports/instagram_v2_7/reportstats/{stats_type}'
}, {
  id: 'a5e119e6ed7c68f1e7b626d4c1fbfc205f4fd5959282f91b8384498340d29f87',
  name: 'Facebook Ad Report Stats Report',
  uriTemplate: '/reports/instagram_v2_8/reportstats/{stats_type}'
}, {
  id: '0f5c9a5c6ed4c515cf2aff804e85f12789c2066150ddc7207d907c593e3164f1',
  name: 'Facebook Ad Report Stats Report',
  uriTemplate: '/reports/facebook_v2_8/reportstats/{stats_type}'
}, {
  id: '2b845a730e731923cbd6ddb841e1c3df87e05ef9c20c6fe3c92724e388737be5',
  name: 'Facebook AdAccounts Report',
  uriTemplate: '/reports/facebook_v2_8/adaccounts/{account_id}'
}, {
  id: 'd919cbe6789c62dd55d1821eec49427f18dccc3e99cf7d1cfff0f856f149fcd8',
  name: 'Facebook AdAccounts Report',
  uriTemplate: '/reports/facebook_v2_7/adaccounts/{account_id}'
}, {
  id: '9c7068e80a021cfd17109798c467ebfd796f111cdd8b0de712a3d27bb3b4cd11',
  name: 'Facebook AdAccounts Report',
  uriTemplate: '/reports/instagram_v2_7/adaccounts/{account_id}'
}, {
  id: '13ba0ce49373bada13e65e7ae88e1de34f6f67164a8d703398d15e1fb3b2c912',
  name: 'Facebook AdAccounts Report',
  uriTemplate: '/reports/instagram_v2_8/adaccounts/{account_id}'
}, {
  id: 'f776ce9d251b2099d41070414b819feee346d378698caaf176f3f6c810a6e327',
  name: 'Facebook Ads Report',
  uriTemplate: '/reports/facebook_v2_7/ads'
}, {
  id: '542fd0daece364ae120a11637160783112b3645c56fa378dac319fbef3cba56d',
  name: 'Facebook Ads Report',
  uriTemplate: '/reports/instagram_v2_8/ads'
}, {
  id: 'e87c4c47919c1e8b70549e56752795505e900df163ec9a28531d6ef52edd0529',
  name: 'Facebook Ads Report',
  uriTemplate: '/reports/instagram_v2_7/ads'
}, {
  id: '0fd7735c8c770d529ad1b9f14bd881e702db38f75e2ebabd8903274127c3d0da',
  name: 'Facebook Ads Report',
  uriTemplate: '/reports/facebook_v2_8/ads'
}, {
  id: '8a7d982316fb5d357fa637d64e56d8514a9f8848912e23c3b3a1d44edbf5771c',
  name: 'Facebook AdSets Report',
  uriTemplate: '/reports/instagram_v2_8/adsets'
}, {
  id: 'a04fa3dede3875ff64f206790c5f22076bef1b23206f4b1eb5e20e3a3c44f82f',
  name: 'Facebook AdSets Report',
  uriTemplate: '/reports/facebook_v2_8/adsets'
}, {
  id: '1dba2d3945c0019694e43a64d61c0c662f944701ab826b79c0c2886c419e774c',
  name: 'Facebook AdSets Report',
  uriTemplate: '/reports/facebook_v2_7/adsets'
}, {
  id: '2351b8f103066e4041beaaeaece591f4cafe98fc1c5b1e8a61d2574c311b080c',
  name: 'Facebook AdSets Report',
  uriTemplate: '/reports/instagram_v2_7/adsets'
}, {
  id: '6f52d196a161c8d535396944e1b442f38700e6fe48963600e29a3d3e4710aef4',
  name: 'Facebook Audience Segmentation Report',
  uriTemplate: '/reports/facebook/segmentation_report'
}, {
  id: 'f59fd82051bb3d588ab483e0e21184e2a88ffb24612ae719755455f31bc6d7dd',
  name: 'Facebook Audience Segmentation Report',
  uriTemplate: '/reports/client/digital/segmentation_report'
}, {
  id: 'fa688cc48e11434d228e8ab8a3cc806341a3e37af4638a8e94b91a1092188bdb',
  name: 'Facebook Audience Segmentation Report',
  uriTemplate: '/reports/client/digital/export_segmentation_report'
}, {
  id: '616a3dbb57d4614f920c3617e8772487b29fa2a5bb4a3335d1b59d6b4804d24c',
  name: 'Facebook Audience Segmentation Report',
  uriTemplate: '/reports/facebook_v2_7/segmentation_report'
}, {
  id: '4ff3c075d11139a6f7d9252c9b327f3b4266f0e0b853c64f562ab432a3614551',
  name: 'Facebook Audience Segmentation Report',
  uriTemplate: '/reports/facebook_v2_8/segmentation_report'
}, {
  id: '66014a8d434bcd9af49fd70d4a6f74ec0f51a8c764501c9e2b20189018ce86ca',
  name: 'Facebook Campaigns Report',
  uriTemplate: '/reports/facebook_v2_7/campaigns'
}, {
  id: 'f8c0fdbcf749ccf57f770f2f1a5f0abac7f677ca05606fb337fb282ae000a84b',
  name: 'Facebook Campaigns Report',
  uriTemplate: '/reports/instagram_v2_8/campaigns'
}, {
  id: 'bdf48a96d9e9760a7a5dc3238a4ee1513d8d141b85b8ab5ccb101e963bce4dae',
  name: 'Facebook Campaigns Report',
  uriTemplate: '/reports/facebook_v2_8/campaigns'
}, {
  id: '19c673c33db07abe837ad527200780daef71692415ead32378806663e8904beb',
  name: 'Facebook Campaigns Report',
  uriTemplate: '/reports/instagram_v2_7/campaigns'
}, {
  id: '09d3d7801f6880a15f887a0379956f3129ba52cc1685ee2e386235ad90a139e5',
  name: 'Facebook Competitive',
  uriTemplate: '/reports/facebook_v2_7/competitive'
}, {
  id: 'e6805a90b66ef3b7ff390c81f72676af5bf929a61781f491bd82f08b41a9c9f7',
  name: 'Facebook Competitive',
  uriTemplate: '/reports/facebook/competitive'
}, {
  id: '00f7f54668b0ce14f61b70f9b3677d0f2c3b91266955f55541ef9aba1db301a6',
  name: 'Facebook Competitive',
  uriTemplate: '/reports/facebook_v2_8/competitive'
}, {
  id: '49af4e9b5b13527a3cab4dc838d6e5491a95e0f2b468357d088bc869458a82be',
  name: 'Facebook Competitor List',
  uriTemplate: '/reports/facebook_v2_7/competitive/competitors'
}, {
  id: '46f3817337796cfdc1d9c3f57f77e46dc8c53edb8f078483ea56ad5e44c72941',
  name: 'Facebook Competitor List',
  uriTemplate: '/reports/facebook_v2_8/competitive/competitors'
}, {
  id: 'c89d323980c8ecc67fa7920cfc10d34fccbf5023debffe71a6e138d6b7dd08a9',
  name: 'Facebook Paid',
  uriTemplate: '/reports/facebook/paid'
}, {
  id: '5dab672535e5b9067d5d04227c1a5dc88211f2a8d61a6a366b322d2856556b66',
  name: 'Facebook Paid',
  uriTemplate: '/reports/facebook_v2_7/paid'
}, {
  id: '9ec7ada081e07edf359b6141bea97eb84e43bfc45617bbda1c0ff574a354ebc2',
  name: 'Facebook Paid',
  uriTemplate: '/reports/facebook_v2_8/paid'
}, {
  id: '2cf2cf5bf6bb77d93e4bee8c60a54c444bba5b187c56af387ecdb4990268ecde',
  name: 'Facebook Posts Report',
  uriTemplate: '/reports/facebook_v2_8/posts'
}, {
  id: '7457cf67382b1a4a4ae6c6c55f337e07c29dff4394edcb7a0f6433d4c0f2f44f',
  name: 'Facebook Posts Report',
  uriTemplate: '/reports/instagram_v2_8/posts'
}, {
  id: '8d4b4ce654fe009348d40ee54059b9722e3204fec6cec6fccfac064e52005e2c',
  name: 'Facebook Raw',
  uriTemplate: '/reports/facebook_v2_8/paid/raw'
}, {
  id: '237f957879e58d3ab1e3a2edd1d2e5541af046ef38ab800f2b30c1d4ed33a86c',
  name: 'Facebook Raw',
  uriTemplate: '/reports/facebook/paid/raw'
}, {
  id: '3dbaf1897c1d9de55e6f1e117f9194378e72f15c0e0722232f36fd1dbde0eb73',
  name: 'Facebook Raw',
  uriTemplate: '/reports/facebook_v2_7/paid/raw'
}, {
  id: 'c6dbe338fe270a986a0d739eb12d55cb82a32cbc73bbe30f7bca7d0cf72f3d82',
  name: 'Facebook Spend by Ad Account',
  uriTemplate: '/reports/customer/unified/spend_by_facebook_ad_account'
}, {
  id: 'e40b825c9a748e084fc4e06c936f0cac906bcaac71a0e08111739c448b783994',
  name: 'fb_post_id',
  uriTemplate: '/reports/facebook/fb_post_id'
}, {
  id: '33fa2d85ffb6f65be0de8dc56b770f7505cb30c091ba9de2cf4ae62741b5d41e',
  name: 'Get Audience Size',
  uriTemplate: '/reports/segmentation/broadcast/audience_aggregator/get_audience_size'
}, {
  id: '379f80fd9a8e3302790f86e07c383c7ac59de664b10d5b5c7253ac502b181f6b',
  name: 'Get Audience Size',
  uriTemplate: '/reports/client/digital/key_metrics'
}, {
  id: 'dd3d78007b4476f087b9cea2eda083697b128d88c636eecd7297d8ad233f388c',
  name: 'Get Audience Size',
  uriTemplate: '/reports/client/digital/get_audience_size'
}, {
  id: 'c09fa43b683c105208c2941a8395ff1064951261a2eae8f97fc96342787d81fc',
  name: 'Get Digital Report',
  uriTemplate: '/reports/client/digital/get_segmentation_report'
}, {
  id: 'daca29daf8617f0d44a1d648e03108dfd2e66bb3bef9c80b994d9ebdc596559e',
  name: 'Get Cohort Taxonomy',
  uriTemplate: '/reports/segmentation/get_cohort_taxonomy'
}, {
  id: '4849703f9c7ec316adc7c4d14283798022e2d442ea47fe0735d173f3b39c2098',
  name: 'Get Unified Cohort Taxonomy',
  uriTemplate: '/reports/segmentation/unified/get_cohort_taxonomy'
}, {
  id: '9d95bd42c687000957423c1a4322ca58f4c348a49b9935418102ae59cdf83c22',
  name: 'Get Pages Audiences',
  uriTemplate: '/reports/segmentation/get_pages_audiences'
}, {
  id: 'cd3c6d939ea28b0859b48d4f974f32f642fd0c26fed3ef44a5e1b6c9da2e219f',
  name: 'Get Key Metrics',
  uriTemplate: '/reports/segmentation/broadcast/audience_aggregator/get_key_metric'
}, {
  id: 'ec5315c7b8d10a6fbd2df5cdda15712411f8345e65d85212b4e537021d7378ca',
  name: 'Get Layered Audience Size',
  uriTemplate: '/reports/segmentation/broadcast/audience_creator/get_audience_size'
}, {
  id: '03454b1ce9ccd1f078b8d652f5a65194cbf3f961e84a25302fbaf15bf5bae79d',
  name: 'Get Layered Cohort Segmentation',
  uriTemplate: '/reports/segmentation/broadcast/audience_creator/get_cohort_segmentation'
}, {
  id: '7abb183c956cf900c61c9ddb3fc3334f5bb279436a84eeb3b88efe1ecff6c60f',
  name: 'Get Layered Unit Segmentation',
  uriTemplate: '/reports/segmentation/broadcast/audience_creator/export_segmentation_report'
}, {
  id: '0891afaddf5ff2029f8bcf4cc7b3046bdde62874eee7fb35f39995d012d81f73',
  name: 'Get Layered Unit Segmentation',
  uriTemplate: '/reports/segmentation/broadcast/audience_creator/get_unit_segmentation'
}, {
  id: '87xv0v9tbmbmubdm1sddsxnduginw6tm72n6lk5bocyqhvdwqbflxhrmu5qmlwq2',
  name: 'Get Layered Index Baseline Detail',
  uriTemplate: '/reports/segmentation/broadcast/audience_creator/get_index_baseline_layered_detail'
}, {
  id: 'dfd435ebb2cd14be95cd37e566cd12ce62e9564840a6baac8b31da6b67ae2a72',
  name: 'Get Segmentation',
  uriTemplate: '/reports/segmentation/broadcast/audience_aggregator/export_segmentation_report'
}, {
  id: 'c0eee2839b30e3db0612c8b819306919f771a351358ae02c709d7f5dfc567518',
  name: 'Get Segmentation',
  uriTemplate: '/reports/segmentation/broadcast/audience_aggregator/get_segmentation'
}, {
  id: 'a42ff4626399a0d8a2033eea8ccad2bd698c40204031e9f98e716a67b732b952',
  name: 'Get Brand Segmentation',
  uriTemplate: '/reports/segmentation/broadcast/audience_brand_explorer/get_brand_segmentation'
}, {
  id: '66c6e9b8c0224b57a6c575e53d19470a02b37fea212cf2ae7340ebdb871e0bea',
  name: 'Get Brand Overlap Segmentation',
  uriTemplate: '/reports/segmentation/broadcast/audience_brand_explorer/get_brand_overlap_segmentation'
}, {
  id: 'baff25f9a5b8a4d41769513f55c7a3a92c3cf431a7775437b2ff5c25e89512f3',
  name: 'iHeartRadio Custom Listener Data',
  uriTemplate: '/reports/iheartmedia/custom_stream_listener'
}, {
  id: '86e48516303f93c81f98e8e62f0cb837543c0a284c5b86813c1dbc9a9b938902',
  name: 'iHeartRadio Listener Data',
  uriTemplate: '/reports/iheartmedia/live_stream_listener'
}, {
  id: '9548568477e563e3aa2a836ac2a59b3d1647d3f706891d4b85a4446e20a1ed63',
  name: 'iHeartRadio Live Streams',
  uriTemplate: '/reports/iheartmedia/live_streams'
}, {
  id: '29ae4060224f5f4af2004b575a3354fc96693944fb596eb7d089e75913271d81',
  name: 'iHeartRadio Top Artist',
  uriTemplate: '/reports/iheartmedia/top_artists'
}, {
  id: '691d15921267abedcb366233933629d034d0a785bdadf3a24394375daa766239',
  name: 'Initiative Report Stasts',
  uriTemplate: '/reports/initiatives/{initiative_id}/stats'
}, {
  id: '53c5305ceb176d66b6c5eb37fe8cb64e08a15b8b8367658a0d192bc63264314b',
  name: 'Instagram Paid',
  uriTemplate: '/reports/instagram/paid'
}, {
  id: '614d9a57faf4eaad0f156c634ed67dab45831f0dbd4ada5099f482520632ac43',
  name: 'Instagram Paid',
  uriTemplate: '/reports/instagram_v2_7/paid'
}, {
  id: 'ed23bdb33fd85de527f23158ae44e0048be83d267c26e0b6454c22c18a4c32d3',
  name: 'Instagram Paid',
  uriTemplate: '/reports/instagram_v2_8/paid'
}, {
  id: 'a97911cbc815d163fb5c87d6d2e22de46d544daefa9a6c512fe408e80916496e',
  name: 'Instagram Raw',
  uriTemplate: '/reports/instagram_v2_7/paid/raw'
}, {
  id: '5ae247d40ddbe33f449be559097ec1b6afdb38fe26973e8b687a157a00f54d11',
  name: 'Instagram Raw',
  uriTemplate: '/reports/instagram/paid/raw'
}, {
  id: 'bd438332f4670d32f0f837ed06cbfe70fb653e38e18d5dc9709d84649aaf79d0',
  name: 'Instagram Raw',
  uriTemplate: '/reports/instagram_v2_8/paid/raw'
}, {
  id: '85f5814bb2d07b321dbbd03b928b25ec2591e2d1741f4490346d7b70144f32b6',
  name: 'Brand Investments',
  uriTemplate: '/reports/investments/brands'
}, {
  id: '0fcca049279d61d8c8c07fb0312fda38ea89f81aa14489d6d67b93d9005c0153',
  name: 'Creative Investments',
  uriTemplate: '/reports/investments/creatives'
}, {
  id: '241f1da90ad34e07fdc62b6e644a2dc2495b8596afe60719b5b82021f094082f',
  name: 'Job Monitor',
  uriTemplate: '/reports/monitor/jobs'
}, {
  id: 'c97d5c5750c0be64c651d719ff81bb57970dbde4f851143078e523d11fbb40d8',
  name: 'Line Item Daily Spend',
  uriTemplate: '/reports/line_items/{line_item_id}/daily_spend'
}, {
  id: 'b8f9884b8e325d5063d9c574ca913684792e446d721ffab674c66b6f8a45036e',
  name: 'Line Item Earned',
  uriTemplate: '/reports/line_items/{line_item_id}/earned'
}, {
  id: '6043f0fe04f97a3fd187f050cada262e337fc4bfd9355cff944377917cfd7947',
  name: 'Line Item Earned Relations',
  uriTemplate: '/reports/awesm/links_stats/relations'
}, {
  id: '44e18dc2e9e6545910a11eb93069143757094ba8827572b242d221a59aa1b50b',
  name: 'Line Item Earned Relations',
  uriTemplate: '/reports/awesm_v1_0/links_stats/relations'
}, {
  id: '911726b9c635dcbafc8f460633a18fdf32480717b332259b30429d06df5d8200',
  name: 'Line Item Pacing',
  uriTemplate: '/reports/line_items/{line_item_id}/pacing'
}, {
  id: '70217bed3cf4607661053f8ef076aa4b6619d6b441c9814874d94261226ca645',
  name: 'LinkedIn Ad Creatives Report',
  uriTemplate: '/reports/linkedin_v1_0/creatives'
}, {
  id: 'ea4de33cdf8796245fa0b41f1768b5f394f9221affda64f4c9b96324d059d32d',
  name: 'LinkedIn Ad Creatives Report',
  uriTemplate: '/reports/linkedin/creatives'
}, {
  id: 'dcd863747c347d2a75a361e6e17a86a7a59f578be21a564ca81f4545b33c31e5',
  name: 'LinkedIn Ad Updates Report',
  uriTemplate: '/reports/linkedin_v1_0/updates'
}, {
  id: '556d653877bf01408c7ff1821390f2f480cb14e04d6aed4c5b7b1caf1553f683',
  name: 'LinkedIn Ad Updates Report',
  uriTemplate: '/reports/linkedin/updates'
}, {
  id: 'cee79ac49b10a615882c348be793825920d2601ba683aadece0e53feb8b2c401',
  name: 'LinkedIn AdAccounts Report',
  uriTemplate: '/reports/linkedin/adaccounts/{account_id}'
}, {
  id: 'a130d61da11f4d229a9b4d01a569c50f79edce5f51ec28f3d56c1ff375e1ce2a',
  name: 'LinkedIn AdAccounts Report',
  uriTemplate: '/reports/linkedin_v1_0/adaccounts/{account_id}'
}, {
  id: '1cce9311d3130a9d4a2af478a70fb8c621a45c591b85338aa71e20c884937136',
  name: 'LinkedIn AdCampaigns Report',
  uriTemplate: '/reports/linkedin_v1_0/campaigns'
}, {
  id: '77e05f8a85a610fab7a0ae3bf5ffb18c2f8fe27acf0a5fc2646cca10694f360d',
  name: 'LinkedIn AdCampaigns Report',
  uriTemplate: '/reports/linkedin/campaigns'
}, {
  id: 'e846076c30ce0006220ab110ff11739f838f92f9f7ed9c35ac7e4497f66a360d',
  name: 'LinkedIn AdCampaigns Stats Report',
  uriTemplate: '/reports/linkedin/reportstats/{stats_type}'
}, {
  id: '9e9844532db3d3600dd7722092c3ef4054644f8a455d90cdf8777f6f130b2a6b',
  name: 'LinkedIn AdCampaigns Stats Report',
  uriTemplate: '/reports/linkedin_v1_0/reportstats/{stats_type}'
}, {
  id: '860a5d9da4f6ed3bd4c85047abee468307d5ee6b5955d43a32c51e875455905e',
  name: 'LinkedIn Paid',
  uriTemplate: '/reports/linkedin/paid'
}, {
  id: '96b94c16fe8609a5dbdd229b3399f25001b945a5fed827b2f7c611aafb370275',
  name: 'LinkedIn Paid',
  uriTemplate: '/reports/linkedin_v1_0/paid'
}, {
  id: '9f24bc36fc4145ce93016c5b72c065ad343c578dc6f452a20f2be748d5283af3',
  name: 'LinkedIn Raw',
  uriTemplate: '/reports/linkedin_v1_0/paid/raw'
}, {
  id: 'a5776c5fe2dcd39740b1a1b7bcf5d5166adabee74f1296c3c4cee2f61d9da7a8',
  name: 'LinkedIn Raw',
  uriTemplate: '/reports/linkedin/paid/raw'
}, {
  id: '3ccdc1d03426de9cecf5bc92b2377d0a28ffe410d9480302f51795fab1a909ec',
  name: 'List Reports',
  uriTemplate: '/reports/reports/'
}, {
  id: '9970ff9faae30e55f739e86bb44c7f9b920c658a90838e55336d2cf14c992bd6',
  name: 'Objects without Salesforce ID',
  uriTemplate: '/reports/customer/unified/items_without_salesforce_id'
}, {
  id: '0e9b1c6a4c2aaf88d9c8115eb6865f18df4dde99bcc817bbbe803377cfdc251a',
  name: 'Paid Benchmarks',
  uriTemplate: '/reports/intelligence/benchmarks'
}, {
  id: '7013414333cfa88713729133773d2dff1c3541c0ae32aa3f8b4a50191563a88e',
  name: 'Snapchat AdAccounts Report',
  uriTemplate: '/reports/snapchat/adaccounts/{account_id}'
}, {
  id: '9c363339a9db2aff7219129c9f00a750877fe16084f70c34decc2e330f5379d0',
  name: 'Snapchat AdAccounts Report',
  uriTemplate: '/reports/snapchat_v1_0/adaccounts/{account_id}'
}, {
  id: 'f80f493717ce25c356664b537d283d0a605c4476e503b7efdb5906d43c125e6c',
  name: 'Snapchat AdCampaigns Stats Report',
  uriTemplate: '/reports/snapchat/reportstats/{stats_type}'
}, {
  id: '33e5b67c7d5172403812176e44265a4b1ded37eb3c95f8c8b47c64a2034c7e71',
  name: 'Snapchat AdCampaigns Stats Report',
  uriTemplate: '/reports/snapchat_v1_0/reportstats/{stats_type}'
}, {
  id: '237ec9f5e4d37f88a4703d421fb16ff55cfaa4d1a5a39c9e2c7c0208aa456e81',
  name: 'Snapchat Ads Report',
  uriTemplate: '/reports/snapchat/ads'
}, {
  id: '9948c28a1be4f491c94a7f5d1a951db33df23df82b0bf02c4313f7a7f4cd7977',
  name: 'Snapchat Ads Report',
  uriTemplate: '/reports/snapchat_v1_0/ads'
}, {
  id: '63c196207492cc6ebbb51f9ccc9d507a87897784e2e6146195f7b48b2f01ad2b',
  name: 'Snapchat AdSquads Report',
  uriTemplate: '/reports/snapchat_v1_0/adsquads'
}, {
  id: 'f478dbb3e5f418157ea6384def98ce2a1bbad873ac2d7fdf307d685ec3bccc5b',
  name: 'Snapchat AdSquads Report',
  uriTemplate: '/reports/snapchat/adsquads'
}, {
  id: '5c958fd5bac9a7220f33f3fd50df7f1c7030cdfa8f83195e99b5aa03c56020b9',
  name: 'Snapchat Campaigns Report',
  uriTemplate: '/reports/snapchat_v1_0/campaigns'
}, {
  id: '07e990c264cf0c1623db3d93553662f4396c3d272ab70a60a5a1f467b65a32a6',
  name: 'Snapchat Campaigns Report',
  uriTemplate: '/reports/snapchat/campaigns'
}, {
  id: '787442919ef26e4d2944ce6f66912d007b4fda726a05043fb7a2cb302c1cfcce',
  name: 'Snapchat Creatives Report',
  uriTemplate: '/reports/snapchat_v1_0/creatives'
}, {
  id: '01d509380871f9b89f222e0420211dc72b0bb8c2b4a18f3b08a0a8203253a9ca',
  name: 'Snapchat Creatives Report',
  uriTemplate: '/reports/snapchat/creatives'
}, {
  id: 'f81734b7f1f5510877eb11a1126aeb9ad7bfc0fc34a0c68061063a0f0cfa2bc0',
  name: 'Snapchat Media Report',
  uriTemplate: '/reports/snapchat/media'
}, {
  id: '1b524acf614c21261c252f9258e1b29f96ccd41f86f89191649817f5d5eacc7a',
  name: 'Snapchat Media Report',
  uriTemplate: '/reports/snapchat_v1_0/media'
}, {
  id: '1f030b948469de41b1c4dfe64eeb07e176a221ddbf87e3c1016c5ba4dc592b80',
  name: 'Snapchat Paid',
  uriTemplate: '/reports/snapchat/paid'
}, {
  id: '6cb221fbc45dfe3d0e217b1a0ae7cbb04f02ff542cb5d69c46cd3213fa3a225a',
  name: 'Snapchat Paid',
  uriTemplate: '/reports/snapchat_v1_0/paid'
}, {
  id: 'd918f4505f1f8d85222f7a56044e00bf5d619e3ca90a12a8531bb353a2ea3baf',
  name: 'Snapchat Raw',
  uriTemplate: '/reports/snapchat/paid/raw'
}, {
  id: '7d47005b5a56590d0b400c86a27642d9c3198b28d43ef4a8e67a64eac1123273',
  name: 'Snapchat Raw',
  uriTemplate: '/reports/snapchat_v1_0/paid/raw'
}, {
  id: '65bd7efe68009e55782686f7749c4df466e377a5632953311d96e2aa429a1c53',
  name: 'Standard Metrics',
  uriTemplate: '/reports/resources/standard_metrics'
}, {
  id: '77b8e7cecf6a52d5b02573133685e20878e7922c5fd59620ab84ece784548c5c',
  name: 'Sunnys Top Tweets',
  uriTemplate: '/reports/twitter/top_tweets'
}, {
  id: '8832855ca2fb774435c432ed52575f968c13e012b98596287705138d1300e7d7',
  name: 'Sunnys Top Tweets',
  uriTemplate: '/reports/twitter_v1_0/top_tweets'
}, {
  id: 'ddbf5ebaa92172107c72c9bcad467371f94151c899835f3b487da288c1cfc848',
  name: 'Twitter AdAccounts Report',
  uriTemplate: '/reports/twitter/adaccounts/{account_id}'
}, {
  id: '525da812348b3007cdbdf53553b1959d533aae93cdd5121961e9c0dac32e48b6',
  name: 'Twitter AdAccounts Report',
  uriTemplate: '/reports/twitter_v1_0/adaccounts/{account_id}'
}, {
  id: 'fa1d4d53f9f5cb82431eb0bed0ccafb588fdb6c9789d905cdd27a3fe10dba6e4',
  name: 'Twitter AdCampaigns Report',
  uriTemplate: '/reports/twitter_v1_0/campaigns'
}, {
  id: '2c20e216d921e9cdbea3ced41a2330f838ba2b8cca3de63c252c4b4578732deb',
  name: 'Twitter AdCampaigns Report',
  uriTemplate: '/reports/twitter/campaigns'
}, {
  id: '0c101467aa8edca8229b868acb92d97f1ebb22b22d21ea266a3df2f4bbb5f3c2',
  name: 'Twitter AdCampaigns Stats Report',
  uriTemplate: '/reports/twitter/reportstats/{stats_type}'
}, {
  id: '717c188a903d0bfcdd937848b10a5dd53204d4ccd3bdbcbe805e64b3d1199303',
  name: 'Twitter AdCampaigns Stats Report',
  uriTemplate: '/reports/twitter_v1_0/reportstats/{stats_type}'
}, {
  id: '2241039217a0d3fbce310061b7355ac84ae809a7ca19ec3c61a001ee2fa56063',
  name: 'Twitter AdPreviews Report',
  uriTemplate: '/reports/twitter/tweets/{tweet_id}/preview'
}, {
  id: 'f37c99fdbff3a1e886e914e339f48e40a8094d7ab21814e1aa974825386acb03',
  name: 'Twitter AdPreviews Report',
  uriTemplate: '/reports/twitter_v1_0/tweets/{tweet_id}/preview'
}, {
  id: 'ca17ca72ca05efde3f76a36b3228bc51d7df12cb23185401ead0e8af3d9a7ee3',
  name: 'Twitter Competitive',
  uriTemplate: '/reports/twitter/competitive'
}, {
  id: 'a530d4cb802cb19102676a607225e4797414cc0e85970abfc3725343ee2581d1',
  name: 'Twitter Competitive',
  uriTemplate: '/reports/twitter_v1_0/competitive'
}, {
  id: '3d01deceea6e44b5533ebfca2db1655d62c34515edefce893ad46d89bd9d1ba4',
  name: 'Twitter Competitor List',
  uriTemplate: '/reports/twitter/competitive/competitors'
}, {
  id: '7367ebe4537933ab938be3b62c08f851622634250bd888f807013cd155ee00a1',
  name: 'Twitter Competitor List',
  uriTemplate: '/reports/twitter_v1_0/competitive/competitors'
}, {
  id: 'f82ef08625bb3290e48f3bd640e046f753b582dec978ee2f2e6d7b9c13116f4e',
  name: 'Twitter Lineitems Report',
  uriTemplate: '/reports/twitter_v1_0/lineitems'
}, {
  id: '4f66cc8dd143fb96f033e458d63e9489f9f1e26cf22fb0d54376a17dc9ab715d',
  name: 'Twitter Lineitems Report',
  uriTemplate: '/reports/twitter/lineitems'
}, {
  id: '1c99d184a5db84af2d5bb62d4f9d3a2707feaf24037f83fb2f4e35d6a1dc6980',
  name: 'Twitter Paid',
  uriTemplate: '/reports/twitter/paid'
}, {
  id: 'a80bbb7f6e95a02b1e75e20ea24aa16c96d2ab54ad26bb00f33061b73af5797d',
  name: 'Twitter Paid',
  uriTemplate: '/reports/twitter_v1_0/paid'
}, {
  id: 'd61163bc5b568d1ab8d3a6542b6ca4d3a39479c18bc5ff2a8f0143a1518c632e',
  name: 'Twitter Promoted Tweets Report',
  uriTemplate: '/reports/twitter_v1_0/promotedtweets'
}, {
  id: '9d3fd7118cffc0e3c362d53d5a892847ec61d9a7d7f3a2716b40dc9454b1c9dc',
  name: 'Twitter Promoted Tweets Report',
  uriTemplate: '/reports/twitter/promotedtweets'
}, {
  id: '8f5045823d40c1533c8536ac44ae138c25a5fcad71cbea744066a8dc1d427345',
  name: 'Twitter Raw',
  uriTemplate: '/reports/twitter/paid/raw'
}, {
  id: '821b0e9100b0963e9b6406cf3f091b59fbbcc9ebec71f4ed318fba18b17463ba',
  name: 'Twitter Raw',
  uriTemplate: '/reports/twitter_v1_0/paid/raw'
}, {
  id: 'b700c6024feae8730e95b443c045cf4a6a3fc3b793fe1c05784a496157bd1d40',
  name: 'Twitter Tweets Report',
  uriTemplate: '/reports/twitter/tweets'
}, {
  id: '7e82785f107da1192dadca69a172d728b1ef75057f999382ab0a96144167839e',
  name: 'Twitter Tweets Report',
  uriTemplate: '/reports/twitter_v1_0/tweets'
}, {
  id: '5f665251170de1c2d589ad3ea1af4110ae1ce2cd4f5ca405b230d0898bab8cb2',
  name: 'Pinterest Paid Report v1.1',
  uriTemplate: '/reports/pinterest/paid'
}, {
  id: '8823f1e4625ceaaec742e15a1a52659e5c39dbf49400f181e421e4fb116a2f1a',
  name: 'AdWords Paid Report',
  uriTemplate: '/reports/adwords/paid'
}, {
  id: 'e04613f4-3e96-435c-9724-0199c856a857',
  name: 'TikTok Paid Report',
  uriTemplate: '/reports/tiktok/paid'
}, {
  id: 'e1d70f72-493a-43cd-8a28-a1ceeebb3bf8',
  name: 'Google Ads Paid Report',
  uriTemplate: '/reports/googleads/paid'
}, {
  id: '6b1d4ea4-5d54-41b9-811e-779a841929f8',
  name: 'Xandr Paid Report',
  uriTemplate: '/reports/xandr/paid'
}, {
  id: '6683421e-0077-4e43-81e9-2e7ac76e6777',
  name: 'Reddit Paid Report',
  uriTemplate: '/reports/reddit/paid'
}, {
  id: '46ddd071-fb46-4527-a092-db84dca9b9c3',
  name: 'Cross Publisher Report',
  uriTemplate: '/reports/crosspublisher/paid'
}, {
  id: '3d2c6646-1e2d-4ed0-9b49-3a00196932da',
  name: 'GroundTruth Paid Report',
  uriTemplate: '/reports/groundtruth/paid'
}, {
  id: 'd15cd072-3345-4c0e-81c7-c08a2ce8d1a2',
  name: 'Snapchat Paid Report',
  uriTemplate: '/reports/snapchat2/paid'
}, {
  id: '7a374f90-5c23-11ed-9b6a-0242ac120002',
  name: 'Linkedin Paid Report',
  uriTemplate: '/reports/linkedin2/paid'
}, {
  id: '3246a726-11cf-4e25-858c-be2a418158b4',
  name: 'Facebook Paid Report',
  uriTemplate: '/reports/facebook2/paid'
}, {
  id: 'f05fcc28-53c0-472e-8156-cc00c23d406f',
  name: 'Instagram Paid Report',
  uriTemplate: '/reports/instagram2/paid'
}, {
  id: '6593188f-ee47-4fd9-a1cd-550dcdb80584',
  name: 'Pinterest Paid Report',
  uriTemplate: '/reports/pinterest2/paid'
}, {
  id: '0349aa35-c902-4a32-93ce-dceb0f0964b2',
  name: 'Twitter Paid Report',
  uriTemplate: '/reports/twitter2/paid'
}, {
  id: '2ec37cb1-7050-450c-9559-6cd6dee7b505',
  name: 'DV360 Paid Report',
  uriTemplate: '/reports/dv360/paid'
}, {
  id: '1727f48f-09d8-4cc2-b92a-269045b3b2ea',
  name: 'Broadcast Paid Report',
  uriTemplate: '/reports/broadcast/paid'
}, {
  id: 'b2dfc4c2-e992-418b-9afd-0b3fe400b39b',
  name: 'Amazon Paid Report',
  uriTemplate: '/reports/amazon/paid'
}, {
  id: '5d720227-b8b4-4248-9349-e18bdd0e28c6',
  name: 'Beeswax Paid Report',
  uriTemplate: '/reports/beeswax/paid'
}, {
  id: '8af5afae-8862-452b-9dc5-aa82c03495d7',
  name: 'GAM Paid Report',
  uriTemplate: '/reports/gam/paid'
}];

exports.default = REPORT_IDS;
//# sourceMappingURL=reportIds.js.map